function fetchConfig(type = "json") {
  var contentType = "application/" + type;
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: contentType,
    },
  };
}
customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        super(),
          (this.form = this.querySelector("form")),
          (this.form.querySelector("[name=id]").disabled = !1),
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
          (this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer")),
          (this.submitButton = this.querySelector('[type="submit"]')),
          document.querySelector("cart-drawer") &&
            this.submitButton.setAttribute("aria-haspopup", "dialog"),
          (this.hideErrors = this.dataset.hideErrors === "true");
      }
      isNumeric(num) {
        return /^-?[0-9]+(?:\.[0-9]+)?$/.test(num + "");
      }
      formDataToFormData(obj, form, namespace) {
        var fd = form || new FormData(),
          formKey;
        obj.forEach((value, key) => {
          namespace
            ? (formKey = namespace + "[" + key + "]")
            : (formKey = property),
            typeof value == "object" && !(value instanceof File)
              ? objectToFormData(value, fd, property)
              : fd.append(formKey, value);
        });
      }
      onSubmitHandlerGiftBox(quanlity, key) {
        const config = fetchConfig("javascript");
        (config.headers["X-Requested-With"] = "XMLHttpRequest"),
          delete config.headers["Content-Type"],
          (document.getElementById("addon1-quantity").value = quanlity);
        const formData = new FormData(document.getElementById("form-addon1"));
        return (
          formData.append("[properties][_parentKey]", key),
          (config.body = formData),
          fetch(`${routes.cart_add_url}`, config).then((response) =>
            response.json()
          )
        );
      }
      onSubmitHandlerGiftCard(quanlity, key) {
        const config = fetchConfig("javascript");
        (config.headers["X-Requested-With"] = "XMLHttpRequest"),
          delete config.headers["Content-Type"],
          (document.getElementById("gift-card-quantity").value = quanlity);
        const formData = new FormData(
          document.getElementById("form-gift-card")
        );
        return (
          formData.append("[properties][_parentKey]", key),
          (config.body = formData),
          fetch(`${routes.cart_add_url}`, config).then((response) =>
            response.json()
          )
        );
      }
      getAddonVariant(mainform) {
        const formData = new FormData(),
          key = new Date().getTime().toString();
        document.getElementById("addon1-quantity").value =
          document.querySelector(
            "product-form.product-form form input[name='quantity']"
          ).value;
        const formAddonData = new FormData(
          document.getElementById("form-addon1")
        );
        return (
          mainform.append("[properties][_itemKey]", key),
          this.formDataToFormData(mainform, formData, "items[0]"),
          formAddonData.append("[properties][_parentKey]", key),
          this.formDataToFormData(formAddonData, formData, "items[1]"),
          formData
        );
      }
      onSubmitHandlerFramedPoster(quanlity, key) {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const framedVariant = document.getElementById("chosenframe")?.value;
        if (!framedVariant || framedVariant === "0") return Promise.resolve(); // nothing selected

        const fd = new FormData();
        fd.append("id", framedVariant);
        fd.append("quantity", quanlity);
        if (key) fd.append("[properties][_parentKey]", key);

        config.body = fd;
        return fetch(`${routes.cart_add_url}`, config).then((r) => r.json());
      }

      convertFormToJSON(elem) {
        let output = {};
        return (
          new FormData(elem).forEach((value, key) => {
            if (Object.prototype.hasOwnProperty.call(output, key)) {
              let current = output[key];
              Array.isArray(current) || (current = output[key] = [current]),
                current.push(value);
            } else output[key] = value;
          }),
          output
        );
      }
      async onSubmitHandler(evt) {
        if (
          (evt.preventDefault(),
          this.submitButton &&
            this.submitButton.getAttribute("aria-disabled") === "true")
        )
          return;
        this.handleErrorMessage(),
          this.submitButton &&
            (this.submitButton.setAttribute("aria-disabled", !0),
            this.submitButton.classList.add("loading")),
          this.querySelector(".loading-overlay__spinner").classList.remove(
            "hidden"
          );
        const config = fetchConfig("javascript");
        (config.headers["X-Requested-With"] = "XMLHttpRequest"),
          delete config.headers["Content-Type"];
        const formData = new FormData(this.form);
        let key = new Date().getTime().toString();
        formData.append("[properties][_itemKey]", key),
          this.cart &&
            (formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            ),
            formData.append("sections_url", window.location.pathname),
            this.cart.setActiveElement(document.activeElement));
        var inputBuyGift = document.getElementById("choose-to-buy");
        if (
          (document.querySelector(".form-pack") &&
            formData.append("[properties][isNotChangeQty]", !0),
          (config.body = formData),
          inputBuyGift && inputBuyGift.checked)
        ) {
          const rectGift = inputBuyGift.getBoundingClientRect(),
            isVisible =
              rectGift.bottom > 0 && rectGift.top < window.innerHeight;
          let quantity = document.querySelector(
            "product-form.product-form form input[name='quantity']"
          ).value;
          const qtyBox = document.querySelector("input[name='quantity-box']");
          qtyBox && ((quantity = qtyBox.value || 1), (key = void 0)),
            isVisible && (await this.onSubmitHandlerGiftBox(quantity, key));
        }
        var inputBuyGiftCard = document.getElementById("choose-to-buy-card");
        if (inputBuyGiftCard && inputBuyGiftCard.checked) {
          const rectGift = inputBuyGiftCard.getBoundingClientRect(),
            isVisible =
              rectGift.bottom > 0 && rectGift.top < window.innerHeight,
            quantity = document.querySelector(
              "product-form.product-form form input[name='quantity']"
            ).value;
          isVisible && (await this.onSubmitHandlerGiftCard(quantity, key));
        }
        {
          let quantity = document.querySelector(
            "product-form.product-form form input[name='quantity']"
          ).value;
          const qtyBox = document.querySelector("input[name='quantity-box']");
          if (qtyBox) {
            quantity = qtyBox.value || 1;
            key = void 0;
          }
          await this.onSubmitHandlerFramedPoster(quantity, key);
        }
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              }),
                this.handleErrorMessage(response.description);
              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", !0),
                this.submitButton.querySelector("span").classList.add("hidden"),
                soldOutMessage.classList.remove("hidden"),
                (this.error = !0);
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            this.error ||
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              }),
              (this.error = !1);
            const quickAddModal = this.closest("quick-add-modal");
            quickAddModal
              ? (document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  {
                    once: !0,
                  }
                ),
                quickAddModal.hide(!0))
              : this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading"),
              this.cart &&
                this.cart.classList.contains("is-empty") &&
                this.cart.classList.remove("is-empty"),
              this.error || this.submitButton.removeAttribute("aria-disabled"),
              this.querySelector(".loading-overlay__spinner").classList.add(
                "hidden"
              );
          });
      }
      handleErrorMessage(errorMessage = !1) {
        (this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper")),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage ||
              this.errorMessageWrapper.querySelector(
                ".product-form__error-message"
              )),
            typeof this.errorMessageWrapper.toggleAttribute == "function" &&
              this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage),
            errorMessage && (this.errorMessage.textContent = errorMessage));
      }
    }
  );

const loadingCustomilyTimeOut = setInterval(() => {
  const customilyElement = document.querySelector("#customily-options");
  if (customilyElement) {
    // handling logic
    document.querySelector("#loading_element").style = "display: none;";
    document.querySelector("#customily-options").style = "display: block;";
    clearInterval(loadingCustomilyTimeOut);
  }
}, 100);

function getCookieGlobal(key) {
  var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
  return keyValue ? keyValue[2] : null;
}
const classClosePhoto = [
  ".closed-photo-image",
  ".upload_image_guidelines",
  ".closed-bg-photo",
];
classClosePhoto.forEach(function (nameClass) {
  var element = document.querySelector(nameClass);
  element &&
    element.addEventListener("click", function () {
      document.querySelector(".modal-custom-image").classList.toggle("hidden"),
        document.querySelector(".closed-bg-photo").classList.toggle("hidden");
    });
});
const classPhotoGift = [
  ".photo-gift",
  ".closed-photo-gift",
  ".closed-bg-photo-gift",
];
classPhotoGift.forEach(function (nameClass) {
  var element = document.querySelector(nameClass);
  element &&
    element.addEventListener("click", function () {
      document.querySelector(".modal-photo-gift").classList.toggle("hidden"),
        document
          .querySelector(".closed-bg-photo-gift")
          .classList.toggle("hidden");
    });
}),
  $(document).on("click", "body", function (e) {
    e.target.closest(".customily-file-input") &&
      document.querySelectorAll(".cl_remove-image").length &&
      callLoop(e.target.closest(".customily-file-input"));
  });

function callLoop(selector) {
  if (!selector) return;
  selector.querySelector(".cl_remove-image").style.display == "none"
    ? selector.classList.remove("arnLabel-show")
    : selector.classList.add("arnLabel-show"),
    setTimeout(() => {
      callLoop(selector);
    }, 1e3);
}
$(function () {
  if ($("#customily-options:not([style*='display: none;'])").length) {
    const timerRemoveLoadingPreview = setInterval(function () {
      if (
        $(
          "#customily-options:not([style*='display: none;']) ~.product-form__buttons #customily-cart-btn:not(.running)"
        ).length
      ) {
        $("#btn-preview-desktop").removeClass("ld-custom");
        $("#btn-preview").removeClass("ld-custom");
        clearInterval(timerRemoveLoadingPreview);
      }
    }, 100);
  }

  var btnBuy = $("#preview-container button[type='submit']");
  btnBuy.on("click", function () {
    $(this).addClass("ld-over-inverse running");
    $(this).append("<div class='ld ld-cycle ld-ring'></div>");
  });
}),
  $("#js-save-properties-product-preview").on("click", function (e) {
  if (
    window.innerWidth < 992 &&
    $(".gallery-wrap.gallery-arrows--false.gallery-thumbnails--left.slider-mobile-gutter").children(".canvas-wrapper").length <= 0
  ) {
    $(".gallery-wrap.gallery-arrows--false.gallery-thumbnails--left.slider-mobile-gutter").prepend($canvasWrapper);
  }
  e.preventDefault();
  $("#customily-cart-btn-preview").addClass("ld-custom");
  $("#customily-cart-btn").trigger("click");
  $("#customily-cart-btn-preview").removeClass("ld-custom");

  $("#preview-container").addClass("hidden");
  }),
  $(document).ready(function () {
    $(window).width() < 798
      ? ($(".date-time-new").on("click", function () {
          $(".new-shipping ~.modal-shipping .wt-grid").toggleClass(
            "box-hover-shipping"
          );
        }),
        $(document).click(function (e) {
          var container = $(".date-time-new");
          !container.is(e.target) &&
            container.has(e.target).length === 0 &&
            $(".new-shipping ~.modal-shipping .wt-grid").addClass(
              "box-hover-shipping"
            );
        }))
      : $(".date-time-new").hover(
          function () {
            $(".new-shipping ~.modal-shipping .wt-grid").toggleClass(
              "box-hover-shipping"
            );
          },
          function () {
            $(".new-shipping ~.modal-shipping .wt-grid").toggleClass(
              "box-hover-shipping"
            );
          }
        );
  }),
  document
    .querySelector(".product-media-modal")
    .addEventListener("click", function (event) {
      const element = event.target,
        children = document.querySelector(
          ".product-media-modal__content.color-background-1.gradient"
        );
      document.querySelector(".product-media-modal[open]") &&
        (children.contains(element) ||
          document.querySelector(".product-media-modal__toggle").click());
    });
const keySaveProperties = "add-to-cart";

function setLocalStorageItem(key, value, ttl) {
  if (!key) return;
  const item = {
    value,
    expiry: ttl ? new Date().getTime() + ttl * 36e5 : null,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

function getLocalStorageItem(key) {
  if (!key) return;
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;
  const item = JSON.parse(itemStr);
  return new Date().getTime() > item.expiry
    ? (localStorage.removeItem(key), null)
    : item.value;
}
const dataPropertiesCache = getLocalStorageItem(keySaveProperties),
  productId = $(".product_form.init").attr("data-product-id");

function addToCart() {
  const urlCurrent = window.location.href;
  if (
    urlCurrent.includes("fri13062202vupg") ||
    urlCurrent.includes("dog09062202nght") ||
    urlCurrent.includes("matching-shirts")
  )
    return;
  const getFieldsForm = $("form[action='/cart/add']").serializeArray();
  var urlCustomization;
  if (
    (getFieldsForm.forEach((field) => {
      field.name === "properties[_customily-customization-url]" &&
        (urlCustomization = field.value);
    }),
    !urlCustomization)
  )
    return;
  const item = {
    variantID: new URL(urlCustomization).searchParams.get("variant"),
    productId,
    urlCustomization,
  };
  if (dataPropertiesCache) {
    const indexProductAdd = dataPropertiesCache.findIndex(
      (item2) => item2.productId === productId
    );
    indexProductAdd !== -1
      ? dataPropertiesCache.splice(indexProductAdd, 1, item)
      : dataPropertiesCache.push(item),
      setLocalStorageItem(keySaveProperties, dataPropertiesCache, 2);
  } else setLocalStorageItem(keySaveProperties, [item], 2);
}
$("product-info form[action='/cart/add']").submit(function () {
  addToCart();
});

function syncLoaddingAddToCart() {
  const timerLoading = setInterval(() => {
    if (
      $("#customily-cart-btn").hasClass("disable-pointer-events") ||
      $("#customily-cart-btn").attr("disabled")
    ) {
      $("#customily-cart-btn-preview").addClass("ld-custom");
    } else {
      $("#customily-cart-btn-preview").removeClass("ld-custom");
      clearInterval(timerLoading);
    }
  }, 100);
}
const waitUntilElementExists = (option, selector, callback) => {
  if (document.querySelector(selector)) return callback(option, selector);
  setTimeout(function () {
    waitUntilElementExists(option, selector, callback);
  }, 200);
};

function FillDataOptionCustomily(option, selector) {
  const el = document.querySelector(selector);
  if (option.type === "Dropdown")
    (el.value = option.value), el.dispatchEvent(new Event("change"));
  else if (option.type === "Swatch") {
    const els = document.querySelectorAll(selector);
    for (const i of els)
      if (i.value === option.value) {
        (i.checked = !0), i.dispatchEvent(new Event("change"));
        return;
      }
  } else if (option.type === "Text Input") {
    el.value = option.value;
    const eventOnChange = new Event("input", {
      bubbles: !0,
      cancelable: !0,
    });
    el.dispatchEvent(eventOnChange);
    return;
  } else
    option.type === "Checkbox" &&
      option.value === "true" &&
      ((el.checked = !0), el.dispatchEvent(new Event("change")));
}

function setCheckedInput(indexItem, arrVariant) {
  var divStyle = $(`[data-option-index="${indexItem}"] input`),
    dataVariant = arrVariant[indexItem];
  divStyle.each(function () {
    if ($(this).val() == dataVariant.trim()) {
      $(this).attr("checked", !0), $(this).prop("checked", !0);
      var swatchElement = $(this).next(),
        swatchValue = swatchElement.data("value").toString();
      $(swatchElement)
        .siblings('input[value="' + swatchValue.replace(/\"/g, '\\"') + '"]')
        .prop("checked", !0)
        .trigger("change");
      var JSONData = $(swatchElement).parents(".product_form").data("product"),
        productSection = ".product-" + productId + " .js-product_section",
        swatchOptions = $(swatchElement)
          .parents(".product_form")
          .find(".swatch_options .swatch");
      swatchOptions.length > 1 &&
        Shopify.linkOptionSelectors(JSONData, productSection);
    } else $(this).removeAttr("checked", !0), $(this).prop("checked", !1);
  });
}

function getShareCustomily() {
  var cacheProductCurrent = dataPropertiesCache.find(function (element) {
    return element.productId === productId;
  });
  const { urlCustomization, variantID } = cacheProductCurrent;
  var optionSelected;
  if (
    ($(".multi_select option").each(function () {
      $(this).val() == variantID &&
        ($(this).attr("selected", "selected"),
        $(this).prop("selected", "selected"),
        (optionSelected = $(this).text()));
    }),
    optionSelected)
  ) {
    var arrVariant = optionSelected.split("/");
    setCheckedInput(0, arrVariant),
      setCheckedInput(1, arrVariant),
      setCheckedInput(2, arrVariant);
  }
  if (urlCustomization) {
    var customizationId = new URLSearchParams(urlCustomization).get(
      "customizationId"
    );
    if (!customizationId) {
      const indexCut = urlCustomization.lastIndexOf("=");
      customizationId = urlCustomization.slice(
        indexCut + 1,
        urlCustomization.length
      );
    }
    window.engraver &&
      window.engraver.getSharedCustomization &&
      window.engraver
        .getSharedCustomization(customizationId)
        .then(async (res) => {
          const { CustomizationData } = res,
            customizationData = JSON.parse(CustomizationData),
            { options } = customizationData;
          for (const option of options) {
            const { sortId, type } = option,
              sortIdDom = `[sort-id="${sortId}"]`;
            var checkVisuallyHiddenElement = document.querySelector(sortIdDom);
            if (
              checkVisuallyHiddenElement &&
              checkVisuallyHiddenElement.attributes["visually-hidden"]
            )
              continue;
            var tagName;
            if (
              ((type === "Swatch" ||
                type === "Checkbox" ||
                type === "Text Input") &&
                (tagName = "input"),
              type === "Dropdown" && (tagName = "select"),
              !tagName)
            )
              continue;
            const el = sortIdDom + " " + tagName;
            waitUntilElementExists(option, el, FillDataOptionCustomily);
          }
        });
  }
}
$(window).on("load", function () {
  if (!document.querySelector(".product__info-wrapper.grid__item")) return;
  const urlCurrent = window.location.href;
  if (
    !(
      urlCurrent.includes("fri13062202vupg") ||
      urlCurrent.includes("dog09062202nght") ||
      urlCurrent.includes("matching-shirts")
    )
  ) {
    if (dataPropertiesCache)
      var cacheProductCurrent = dataPropertiesCache.find(function (element) {
        return element.productId === productId;
      });
    cacheProductCurrent &&
      $(".notification-shipping").hasClass("hidden") &&
      modalConfirm("getShareCustomily");
  }
});

function closeModalConfirm() {
  $("#wrapper-modal-confirm").removeClass("is-open");
}
$(
  ".handle-cancel-confirm-modal, .overlay-modal-confirm,.btn-closed-reorder"
).on("click", function () {
  $("#js-btn-customzize").click(), closeModalConfirm();
}),
  $(".handle-ok-confirm-modal").on("click", function () {
    var redirect = $(this).attr("redirect");
    redirect == "getShareCustomily"
      ? getShareCustomily()
      : handleConfirmRemoveCart(redirect),
      closeModalConfirm();
  });

function initOpenModal() {
  $("#wrapper-modal-confirm").addClass("is-open");
}

function modalConfirm(redirect) {
  initOpenModal(), $(".handle-ok-confirm-modal").attr("redirect", redirect);
}
var getThisElementHandle;

function handleConfirmRemoveCart(redirect) {
  const cartItem = {
    lineID: $(getThisElementHandle).parents("[data-cart-item]").data("line-id"),
    quantity: 0,
    $element: $(getThisElementHandle).parents("[data-cart-item]"),
  };
  cartItem.$element.addClass("animated fadeOutLeft"),
    updateCartItem(cartItem, redirect);
}
$(document).on("click", ".button-minus-box, .button-plus-box", function () {
  const $input = $('input[name="quantity-box"]');
  let qty = parseInt($input.val(), 10) || 0;
  $(this).hasClass("button-minus-box") ? qty > 1 && qty-- : qty++,
    $input.val(qty);
}),
  $(document).ready(function () {
    const pack = $(".qty_default_box"),
      qty_box = $('[name="quantity-box"]');
    if (pack.length && qty_box.length) {
      const count = parseInt(pack.text(), 10) || 1;
      qty_box.val(count);
    }
  });
